(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beese-category-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    root.querySelectorAll('[data-category-shop]').forEach(shop => {
      if (shop.dataset.ready) return;
      shop.dataset.ready = 'true';
      const links = Array.from(shop.querySelectorAll('[data-category]'));
      const items = Array.from(shop.querySelectorAll('[data-product-category]'));
      const count = shop.querySelector('.bt-count');
      function filter(category) {
        if (!links.some(link => link.dataset.category === category)) category = 'all';
        let visible = 0;
        items.forEach(item => {
          item.hidden = category !== 'all' && item.dataset.productCategory !== category;
          if (!item.hidden) visible++;
        });
        links.forEach(link => {
          if (link.dataset.category === category) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        count.textContent = visible + ' ' + (visible === 1 ? shop.dataset.singular : shop.dataset.plural);
      }
      links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        history.replaceState(null, '', '#' + link.dataset.category);
        filter(link.dataset.category);
      }));
      window.addEventListener('hashchange', () => filter(location.hash.slice(1)));
      filter(location.hash.slice(1) || 'all');
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beese-football-parent"] && !Shopify.designMode) return;
  try {
    
(() => {
function initialize(scope) {
scope.querySelectorAll('[data-beese-parent]').forEach(root => {
if(root.dataset.initialized) return;
root.dataset.initialized='true';
const form=root.querySelector('form'), variants=JSON.parse(root.querySelector('[data-bfp-variants]').textContent);
const thumbs=[...root.querySelectorAll('[data-gallery-index]')], hero=root.querySelector('.bfp-hero');
const addonPosition=Number(root.dataset.addonPosition)-1;
const front=root.querySelector('.bfp-front-placement input'), back=root.querySelector('.bfp-back-placement input'), none=root.querySelector('.bfp-no-back input');
const frontName=root.querySelector('[data-front-name]'), frontNumber=root.querySelector('[data-front-number]'), backFields=[...root.querySelectorAll('[data-back]')];
const button=root.querySelector('.bfp-add'), status=root.querySelector('.bfp-status');
let galleryIndex=0;
const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency}).format(cents/100);
function showImage(url,alt){if(!hero||!url)return;hero.removeAttribute('srcset');hero.src=url;hero.alt=alt||'';}
function gallery(index){if(!thumbs.length)return;galleryIndex=(index+thumbs.length)%thumbs.length;showImage(thumbs[galleryIndex].dataset.image,thumbs[galleryIndex].dataset.alt);thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===galleryIndex)));}
thumbs.forEach((t,i)=>t.addEventListener('click',()=>gallery(i)));
root.querySelector('.bfp-prev').addEventListener('click',()=>gallery(galleryIndex-1));
root.querySelector('.bfp-next').addEventListener('click',()=>gallery(galleryIndex+1));
function options(){const opts=variants[0]?.options.map(()=>null)||[];form.querySelectorAll('[data-option-position]:checked').forEach(input=>opts[Number(input.dataset.optionPosition)-1]=input.value);if(variants[0]?.options.length===1&&variants[0].options[0]==='Default Title')opts[0]='Default Title';return opts;}
function find(opts){return variants.find(v=>v.options.every((value,i)=>value===opts[i]));}
function update(){

const type=form.querySelector('[data-option-position="1"]:checked')?.value;
const colorInputs=[...form.querySelectorAll('[data-option-position="2"]')];
colorInputs.forEach(input=>{const valid=variants.some(v=>v.options[0]===type&&v.options[1]===input.value);input.disabled=!valid;input.closest('label').hidden=!valid;});
let color=colorInputs.find(input=>input.checked&&!input.disabled);
if(!color){color=colorInputs.find(input=>!input.disabled);if(color)color.checked=true;}
const engraveOnly=type==='22 oz Skinny Tumbler'&&['Black / Multi','Black / Rose Gold'].includes(color?.value);
const fullColor=form.querySelector('input[name="properties[Decoration Method]"][value="Full Color"]');
const laser=form.querySelector('input[name="properties[Decoration Method]"][value="Laser Engraved"]');
if(fullColor){fullColor.disabled=engraveOnly;fullColor.closest('label').setAttribute('aria-disabled',String(engraveOnly));if(engraveOnly&&laser)laser.checked=true;}
root.querySelector('[data-method-note]').textContent=engraveOnly?'This finish is available with laser engraving only.':'';
const design=form.querySelector('[data-front-rule]:checked'), rule=design?.dataset.frontRule||'none';
const frontRequired=rule!=='none', allowBack=design?.dataset.allowBack==='true'&&addonPosition>=0;
front.disabled=!frontRequired;back.disabled=!allowBack;none.disabled=false;
root.querySelector('.bfp-front-placement').hidden=!frontRequired;
root.querySelector('.bfp-back-placement').hidden=!allowBack;
root.querySelector('.bfp-no-back').hidden=!allowBack;
root.querySelector('[data-placement]').hidden=!design;
if(front.checked||(!allowBack&&back.checked))none.checked=true;
const withBack=allowBack&&back.checked;
frontName.disabled=!frontRequired;frontName.required=frontRequired;frontNumber.disabled=rule!=='name_number';frontNumber.required=rule==='name_number';
root.querySelector('[data-front-name-label]').hidden=!frontRequired;root.querySelector('[data-front-number-label]').hidden=rule!=='name_number';
backFields.forEach(input=>{input.disabled=!withBack;input.required=withBack;});
root.querySelectorAll('[data-back-label]').forEach(label=>label.hidden=!allowBack);
const opts=options();if(addonPosition>=0)opts[addonPosition]=withBack?root.dataset.addonYes:root.dataset.addonNone;
const variant=find(opts);
root.querySelector('[data-bfp-variant]').value=variant?.id||'';
button.disabled=!variant||!variant.available;
status.textContent=!variant?'This combination needs matching product variants before it can be ordered.':!variant.available?'This combination is currently unavailable.':'';
if(variant){root.querySelector('[data-bfp-price]').textContent=money(variant.price);root.querySelector('[data-bfp-button-price]').textContent=money(variant.price);}
if(allowBack){const baseOpts=[...opts],paidOpts=[...opts];baseOpts[addonPosition]=root.dataset.addonNone;paidOpts[addonPosition]=root.dataset.addonYes;const base=find(baseOpts),paid=find(paidOpts);const valid=base&&paid&&paid.price-base.price===400;back.disabled=!valid;root.querySelector('[data-addon-price]').textContent=valid?'— +'+money(paid.price-base.price):'— unavailable';if(withBack&&!valid){button.disabled=true;status.textContent='Back personalization needs a correctly priced add-on variant.';}}
root.querySelector('[data-placement-note]').textContent=frontRequired?((rule==='name_number'?'This design requires your front name and number.':'This design requires your front name.')+(withBack?' Back name and number are included in the selected price.':'')):withBack?'Your back name and number are included in the selected price.':'The selected design is finished front artwork. No additional customization is included.';
form.querySelectorAll('[data-color-label]').forEach(label=>{const selected=label.closest('fieldset').querySelector('input:checked');label.textContent=selected?selected.value+' selected':'';});
}
form.addEventListener('change',event=>{if(event.target.matches('[data-front-rule]')){showImage(event.target.dataset.designImage,event.target.dataset.designAlt);thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}update();});
form.addEventListener('submit',event=>{update();form.querySelectorAll('input[required]:not(:disabled)').forEach(input=>input.setCustomValidity(input.value.trim()?'':'Please enter this field.'));if(!form.reportValidity()||button.disabled)event.preventDefault();});
form.querySelectorAll('input').forEach(input=>input.addEventListener('input',()=>input.setCustomValidity('')));
const selected=variants.find(v=>String(v.id)===root.querySelector('[data-bfp-variant]').value);
if(selected){form.querySelectorAll('[data-option-position]').forEach(input=>{input.checked=input.value===selected.options[Number(input.dataset.optionPosition)-1];});if(addonPosition>=0&&selected.options[addonPosition]===root.dataset.addonYes){const compatible=form.querySelector('[data-allow-back="true"][data-front-rule="none"]');if(compatible){compatible.checked=true;back.checked=true;}}}
update();
});
}
initialize(document);document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beese-personalized"] && !Shopify.designMode) return;
  try {
    
(() => {
function initialize(scope) {
scope.querySelectorAll('[data-beese-product]').forEach(root => {
if(root.dataset.initialized) return;
root.dataset.initialized='true';
const form=root.querySelector('form'), variants=JSON.parse(root.querySelector('[data-bpp-variants]').textContent);
const thumbs=[...root.querySelectorAll('[data-gallery-index]')], hero=root.querySelector('.bpp-hero');
const addonPosition=Number(root.dataset.addonPosition)-1;
const front=root.querySelector('.bpp-front-placement input'), back=root.querySelector('.bpp-back-placement input'), none=root.querySelector('.bpp-no-back input');
const frontName=root.querySelector('[data-front-name]'), frontNumber=root.querySelector('[data-front-number]'), backFields=[...root.querySelectorAll('[data-back]')];
const button=root.querySelector('.bpp-add'), status=root.querySelector('.bpp-status');
let galleryIndex=0;
const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency}).format(cents/100);
function showImage(url,alt){if(!hero||!url)return;hero.removeAttribute('srcset');hero.src=url;hero.alt=alt||'';}
function gallery(index){if(!thumbs.length)return;galleryIndex=(index+thumbs.length)%thumbs.length;showImage(thumbs[galleryIndex].dataset.image,thumbs[galleryIndex].dataset.alt);thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===galleryIndex)));}
thumbs.forEach((t,i)=>t.addEventListener('click',()=>gallery(i)));
root.querySelector('.bpp-prev').addEventListener('click',()=>gallery(galleryIndex-1));
root.querySelector('.bpp-next').addEventListener('click',()=>gallery(galleryIndex+1));
function options(){const opts=variants[0]?.options.map(()=>null)||[];form.querySelectorAll('[data-option-position]:checked').forEach(input=>opts[Number(input.dataset.optionPosition)-1]=input.value);if(variants[0]?.options.length===1&&variants[0].options[0]==='Default Title')opts[0]='Default Title';return opts;}
function find(opts){return variants.find(v=>v.options.every((value,i)=>value===opts[i]));}
function update(){
const design=form.querySelector('[data-front-rule]:checked'), rule=design?.dataset.frontRule||'none';
const frontRequired=rule!=='none', allowBack=!frontRequired&&design?.dataset.allowBack==='true'&&addonPosition>=0;
front.disabled=!frontRequired;back.disabled=!allowBack;none.disabled=frontRequired;
root.querySelector('.bpp-front-placement').hidden=!frontRequired;
root.querySelector('.bpp-back-placement').hidden=!allowBack;
root.querySelector('.bpp-no-back').hidden=frontRequired;
root.querySelector('[data-placement]').hidden=!design;
if(frontRequired)front.checked=true;else if(front.checked||(!allowBack&&back.checked))none.checked=true;
const withBack=allowBack&&back.checked;
frontName.disabled=!frontRequired;frontName.required=frontRequired;frontNumber.disabled=rule!=='name_number';frontNumber.required=rule==='name_number';
root.querySelector('[data-front-name-label]').hidden=!frontRequired;root.querySelector('[data-front-number-label]').hidden=rule!=='name_number';
backFields.forEach(input=>{input.disabled=!withBack;input.required=withBack;});
root.querySelectorAll('[data-back-label]').forEach(label=>label.hidden=!allowBack);
const opts=options();if(addonPosition>=0)opts[addonPosition]=withBack?root.dataset.addonYes:root.dataset.addonNone;
const variant=find(opts);
root.querySelector('[data-bpp-variant]').value=variant?.id||'';
button.disabled=!variant||!variant.available;
status.textContent=!variant?'This combination needs matching product variants before it can be ordered.':!variant.available?'This combination is currently unavailable.':'';
if(variant){root.querySelector('[data-bpp-price]').textContent=money(variant.price);root.querySelector('[data-bpp-button-price]').textContent=money(variant.price);}
if(allowBack){const baseOpts=[...opts],paidOpts=[...opts];baseOpts[addonPosition]=root.dataset.addonNone;paidOpts[addonPosition]=root.dataset.addonYes;const base=find(baseOpts),paid=find(paidOpts);const valid=base&&paid&&paid.price>base.price;back.disabled=!valid;root.querySelector('[data-addon-price]').textContent=valid?'— +'+money(paid.price-base.price):'— unavailable';if(withBack&&!valid){button.disabled=true;status.textContent='Back personalization needs a correctly priced add-on variant.';}}
root.querySelector('[data-placement-note]').textContent=frontRequired?(rule==='name_number'?'This design requires your front name and number.':'This design requires your front name.'):withBack?'Your back name and number are included in the selected price.':'The selected design is finished front artwork. No additional customization is included.';
form.querySelectorAll('[data-color-label]').forEach(label=>{const selected=label.closest('fieldset').querySelector('input:checked');label.textContent=selected?selected.value+' selected':'';});
}
form.addEventListener('change',event=>{if(event.target.matches('[data-front-rule]')){showImage(event.target.dataset.designImage,event.target.dataset.designAlt);thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}update();});
form.addEventListener('submit',event=>{update();form.querySelectorAll('input[required]:not(:disabled)').forEach(input=>input.setCustomValidity(input.value.trim()?'':'Please enter this field.'));if(!form.reportValidity()||button.disabled)event.preventDefault();});
form.querySelectorAll('input').forEach(input=>input.addEventListener('input',()=>input.setCustomValidity('')));
const selected=variants.find(v=>String(v.id)===root.querySelector('[data-bpp-variant]').value);
if(selected){form.querySelectorAll('[data-option-position]').forEach(input=>{input.checked=input.value===selected.options[Number(input.dataset.optionPosition)-1];});if(addonPosition>=0&&selected.options[addonPosition]===root.dataset.addonYes){const compatible=form.querySelector('[data-allow-back="true"][data-front-rule="none"]');if(compatible){compatible.checked=true;back.checked=true;}}}
update();
});
}
initialize(document);document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sports-water-bottle"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-sports-bottle]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const variants = JSON.parse(root.querySelector('[data-swb-variants]').textContent);
    const form = root.querySelector('form');
    const thumbs = [...root.querySelectorAll('[data-gallery-index]')];
    const hero = root.querySelector('.swb-hero');
    let galleryIndex = 0;
    function gallery(index) {
      if (!thumbs.length || !hero) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      hero.removeAttribute('srcset');
      hero.src = thumbs[galleryIndex].dataset.image;
      hero.alt = thumbs[galleryIndex].dataset.alt;
      thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed', String(i === galleryIndex)));
    }
    thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => gallery(i)));
    root.querySelector('.swb-prev').addEventListener('click', () => gallery(galleryIndex - 1));
    root.querySelector('.swb-next').addEventListener('click', () => gallery(galleryIndex + 1));
    const fronts = [...root.querySelectorAll('[data-front]')];
    const backs = [...root.querySelectorAll('[data-back]')];
    const frontPlacement = root.querySelector('.swb-front-placement input');
    const backPlacement = root.querySelector('.swb-back-placement input');
    const noBack = root.querySelector('.swb-no-back input');
    function update() {
      const player = form.querySelector('[name="properties[Design Style]"]:checked').value === 'Football Player';
      frontPlacement.disabled = !player;
      backPlacement.disabled = player;
      noBack.disabled = player;
      root.querySelector('.swb-no-back').hidden = player;
      if (player) frontPlacement.checked = true;
      else if (frontPlacement.checked) noBack.checked = true;
      const withBack = !player && backPlacement.checked;
      fronts.forEach(input => {input.disabled = !player; input.required = player;});
      backs.forEach(input => {input.disabled = !withBack; input.required = withBack;});
      const size = form.querySelector('[name="swb-size"]:checked').value;
      const color = form.querySelector('[name="properties[Bottle Color]"]:checked').value;
      root.querySelector('.swb-selected-color').textContent = color + ' selected';
      const back = withBack ? 'Name + Number (+$4)' : 'None';
      const variant = variants.find(v => v.options[0] === size && v.options[1] === color && v.options[2] === back);
      const button = root.querySelector('.swb-add');
      root.querySelector('[data-swb-variant]').value = variant ? variant.id : '';
      button.disabled = !variant || !variant.available;
      const status = root.querySelector('.swb-status');
      status.textContent = !variant ? 'This template needs matching Size, Color and Back Personalization variants before orders can be placed.' : !variant.available ? 'This combination is currently unavailable.' : '';
      if (variant) {
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(variant.price / 100);
        root.querySelector('[data-swb-price]').textContent = money;
        root.querySelector('[data-swb-button-price]').textContent = money;
      }
    }
    form.addEventListener('change', event => {if (event.target.matches('[data-design-index]')) gallery(Number(event.target.dataset.designIndex)); update();});
    form.addEventListener('submit', event => {
      update();
      [...fronts,...backs].forEach(input => {if (!input.disabled && input.required && !input.value.trim()) input.setCustomValidity('Please enter this field.');});
      if (!form.reportValidity() || root.querySelector('.swb-add').disabled) event.preventDefault();
    });
    [...fronts,...backs].forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));
    const selected = variants.find(v => String(v.id) === root.querySelector('[data-swb-variant]').value);
    if (selected) {
      const sizeRadio = [...form.querySelectorAll('[name="swb-size"]')].find(i => i.value === selected.options[0]);
      const colorRadio = [...form.querySelectorAll('[name="properties[Bottle Color]"]')].find(i => i.value === selected.options[1]);
      if (sizeRadio) sizeRadio.checked = true;
      if (colorRadio) colorRadio.checked = true;
    }
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
